import React, { useEffect, useState } from "react";
import { GoAlert } from "react-icons/go";
import { BsFileEarmark } from "react-icons/bs";
import styled from "styled-components";
import { FieldGrid } from "../pages/candidate/FieldGrid";
import { getDayPart, getMonthPart, getYearPart } from "../utils/date";
import Copy from "./Copy";
import { FormControl } from "baseui/form-control";
import { DateTime } from "luxon";
import enums from "../utils/enums";

const Container = styled.div``;
const Section = styled.div``;

const CandidateIdentityDocument = (props: any) => {
	const [identityDocumentType, setIdentityDocumentType] = useState(null as any);

	const onLoad = () => {
		setIdentityDocumentType(
			enums.candidateIdentityDocumentType.find(
				(item: any) =>
					item.value === props.fields["CandidateIdentityDocument.Type"]
			)
		);
	};

	useEffect(() => {
		onLoad();
	}, []);

	return (
		<>
			{identityDocumentType && identityDocumentType.mode === "none" ? (
				<>
					<Section>
						<Container>
							<h2 style={{ color: "red" }}>
								<GoAlert /> No Identity Document Provided <GoAlert />
							</h2>
							<div>
								<p>
									The candidate was unable to provide a Driver's License /
									Passport for review. Please contact the candidate to verify
									their identity in another way.
								</p>
							</div>
						</Container>
					</Section>
					<hr />
				</>
			) : (
				identityDocumentType && (
					<>
						<Section>
							<Container>
								{props.mode === "moj" && <h2>{identityDocumentType.label}</h2>}

								<FieldGrid>
									<div>
										<FormControl
											label={
												props.mode === "detail"
													? `${identityDocumentType.label}: ${identityDocumentType.documentNumberLabel}`
													: identityDocumentType.documentNumberLabel
											}
										>
											<Copy>
												{
													props.fields[
														"CandidateIdentityDocument.DocumentNumber"
													]
												}
											</Copy>
										</FormControl>
									</div>
									<div>
										<FormControl label={identityDocumentType.expiryLabel}>
											<Copy
												style={
													DateTime.fromISO(
														props.fields["CandidateIdentityDocument.ExpiryDate"]
													) < DateTime.now()
														? { color: "red" }
														: DateTime.now().plus({ months: 12 }).toJSDate() >
														  DateTime.fromISO(
																props.fields[
																	"CandidateIdentityDocument.ExpiryDate"
																]
														  ).toJSDate()
														? { color: "orange" }
														: {}
												}
											>
												{DateTime.fromISO(
													props.fields["CandidateIdentityDocument.ExpiryDate"]
												).toLocaleString(DateTime.DATE_FULL)}
											</Copy>
										</FormControl>
									</div>
									{props.fields["CandidateIdentityDocument.Type.ToString"] ===
										"NZDriversLicense" && (
										<>
											<div>
												<FormControl label={"License class"}>
													<div>
														{
															props.fields[
																"CandidateIdentityDocument.OtherInformation"
															]?.class
														}
													</div>
												</FormControl>
											</div>{" "}
											<div> </div>{" "}
										</>
									)}
									{(() => {
										var response = [];
										for (var fileTypeKey in identityDocumentType.files) {
											const fileType = identityDocumentType.files[fileTypeKey];
											response.push(
												<div>
													<FormControl label={fileType}>
														<div>
															{props.fields["CandidateIdentityDocument.Files"][
																fileTypeKey
															].contentType &&
															props.fields["CandidateIdentityDocument.Files"][
																fileTypeKey
															].contentType.startsWith("image/") ? (
																<>
																	<a
																		href={
																			props.fields[
																				"CandidateIdentityDocument.Files"
																			][fileTypeKey].privateUrl
																		}
																		target="_blank"
																		rel="noopener"
																		style={{
																			textDecoration: "none",
																		}}
																	>
																		<img
																			src={
																				props.fields[
																					"CandidateIdentityDocument.Files"
																				][fileTypeKey].privateUrl
																			}
																		/>
																	</a>
																</>
															) : (
																<>
																	<div>
																		<a
																			href={
																				props.fields[
																					"CandidateIdentityDocument.Files"
																				][fileTypeKey].privateUrl
																			}
																			target="_blank"
																			rel="noopener"
																			style={{
																				textDecoration: "none",
																			}}
																		>
																			<BsFileEarmark /> <span>Download</span>{" "}
																		</a>
																	</div>
																</>
															)}
														</div>
													</FormControl>
												</div>
											);
										}
										return response;
									})()}
								</FieldGrid>
							</Container>
						</Section>
					</>
				)
			)}
		</>
	);
};

export default CandidateIdentityDocument;
